import axios from 'axios';
import { buildApiUrl } from '../config/api';


export const DocumentServices = {
    getDocuments: async (token) => {
        try {
            const response = await axios.get(
                buildApiUrl('/api/ajustes/tipodocumentos'),
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            return response.data.tiposDocumentos;
        } catch (error) {
            console.error('Error en DocumentServices:', error);
            throw error;
        }
    },
};
